function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list/indentcommand
 */
import { Command } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';
/**
 * The list indent command. It is used by the {@link module:list/list~List list feature}.
 *
 * @extends module:core/command~Command
 */

var IndentCommand = /*#__PURE__*/function (_Command) {
  _inherits(IndentCommand, _Command);

  var _super = _createSuper(IndentCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {'forward'|'backward'} indentDirection The direction of indent. If it is equal to `backward`, the command
   * will outdent a list item.
   */
  function IndentCommand(editor, indentDirection) {
    var _this;

    _classCallCheck(this, IndentCommand);

    _this = _super.call(this, editor);
    /**
     * Determines by how much the command will change the list item's indent attribute.
     *
     * @readonly
     * @private
     * @member {Number}
     */

    _this._indentBy = indentDirection == 'forward' ? 1 : -1;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IndentCommand, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this._checkEnabled();
    }
    /**
     * Indents or outdents (depending on the {@link #constructor}'s `indentDirection` parameter) selected list items.
     *
     * @fires execute
     * @fires _executeCleanup
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var model = this.editor.model;
      var doc = model.document;
      var itemsToChange = Array.from(doc.selection.getSelectedBlocks());
      model.change(function (writer) {
        var lastItem = itemsToChange[itemsToChange.length - 1]; // Indenting a list item should also indent all the items that are already sub-items of indented item.

        var next = lastItem.nextSibling; // Check all items after last indented item, as long as their indent is bigger than indent of that item.

        while (next && next.name == 'listItem' && next.getAttribute('listIndent') > lastItem.getAttribute('listIndent')) {
          itemsToChange.push(next);
          next = next.nextSibling;
        } // We need to be sure to keep model in correct state after each small change, because converters
        // bases on that state and assumes that model is correct.
        // Because of that, if the command outdents items, we will outdent them starting from the last item, as
        // it is safer.


        if (_this2._indentBy < 0) {
          itemsToChange = itemsToChange.reverse();
        }

        var _iterator = _createForOfIteratorHelper(itemsToChange),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            var indent = item.getAttribute('listIndent') + _this2._indentBy; // If indent is lower than 0, it means that the item got outdented when it was not indented.
            // This means that we need to convert that list item to paragraph.


            if (indent < 0) {
              // To keep the model as correct as possible, first rename listItem, then remove attributes,
              // as listItem without attributes is very incorrect and will cause problems in converters.
              // No need to remove attributes, will be removed by post fixer.
              writer.rename(item, 'paragraph');
            } // If indent is >= 0, change the attribute value.
            else {
                writer.setAttribute('listIndent', indent, item);
              }
          }
          /**
           * Event fired by the {@link #execute} method.
           *
           * It allows to execute an action after executing the {@link ~IndentCommand#execute} method, for example adjusting
           * attributes of changed list items.
           *
           * @protected
           * @event _executeCleanup
           */

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this2.fire('_executeCleanup', itemsToChange);
      });
    }
    /**
     * Checks whether the command can be enabled in the current context.
     *
     * @private
     * @returns {Boolean} Whether the command should be enabled.
     */

  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      // Check whether any of position's ancestor is a list item.
      var listItem = first(this.editor.model.document.selection.getSelectedBlocks()); // If selection is not in a list item, the command is disabled.

      if (!listItem || !listItem.is('element', 'listItem')) {
        return false;
      }

      if (this._indentBy > 0) {
        // Cannot indent first item in it's list. Check if before `listItem` is a list item that is in same list.
        // To be in the same list, the item has to have same attributes and cannot be "split" by an item with lower indent.
        var indent = listItem.getAttribute('listIndent');
        var type = listItem.getAttribute('listType');
        var prev = listItem.previousSibling;

        while (prev && prev.is('element', 'listItem') && prev.getAttribute('listIndent') >= indent) {
          if (prev.getAttribute('listIndent') == indent) {
            // The item is on the same level.
            // If it has same type, it means that we found a preceding sibling from the same list.
            // If it does not have same type, it means that `listItem` is on different list (this can happen only
            // on top level lists, though).
            return prev.getAttribute('listType') == type;
          }

          prev = prev.previousSibling;
        } // Could not find similar list item, this means that `listItem` is first in its list.


        return false;
      } // If we are outdenting it is enough to be in list item. Every list item can always be outdented.


      return true;
    }
  }]);

  return IndentCommand;
}(Command);

export { IndentCommand as default };